// Strapi validation responses carry the useful explanation outside Axios.message.
export const apiErrorMessage = (error) => {
  const message = error?.response?.data?.error?.message;
  return typeof message === 'string' && message.trim() ? message.trim() : null;
};

export const apiErrorContext = (error) => {
  if (!error?.response && !error?.config) return undefined;
  let path;
  try {
    if (error.config?.url) path = new URL(error.config.url, 'https://local.invalid').pathname;
  } catch { /* A malformed URL must not prevent error reporting. */ }
  const message = apiErrorMessage(error);
  return {
    status: error.response?.status,
    method: error.config?.method?.toUpperCase(),
    path,
    name: error.response?.data?.error?.name,
    // No request body, response details, headers or authentication tokens.
    message: message?.replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]')
      .replace(/\+\d[\d\s()-]{6,}\d/g, '[phone]').slice(0, 500),
  };
};
